/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CountAccountsApiV2LedgersLedgerCanisterIdAccountsCountGetRequest = {
  ledgerCanisterId: string;
};

/** @internal */
export const CountAccountsApiV2LedgersLedgerCanisterIdAccountsCountGetRequest$inboundSchema:
  z.ZodType<
    CountAccountsApiV2LedgersLedgerCanisterIdAccountsCountGetRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    ledger_canister_id: z.string(),
  }).transform((v) => {
    return remap$(v, {
      "ledger_canister_id": "ledgerCanisterId",
    });
  });

/** @internal */
export type CountAccountsApiV2LedgersLedgerCanisterIdAccountsCountGetRequest$Outbound =
  {
    ledger_canister_id: string;
  };

/** @internal */
export const CountAccountsApiV2LedgersLedgerCanisterIdAccountsCountGetRequest$outboundSchema:
  z.ZodType<
    CountAccountsApiV2LedgersLedgerCanisterIdAccountsCountGetRequest$Outbound,
    z.ZodTypeDef,
    CountAccountsApiV2LedgersLedgerCanisterIdAccountsCountGetRequest
  > = z.object({
    ledgerCanisterId: z.string(),
  }).transform((v) => {
    return remap$(v, {
      ledgerCanisterId: "ledger_canister_id",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace CountAccountsApiV2LedgersLedgerCanisterIdAccountsCountGetRequest$ {
  /** @deprecated use `CountAccountsApiV2LedgersLedgerCanisterIdAccountsCountGetRequest$inboundSchema` instead. */
  export const inboundSchema =
    CountAccountsApiV2LedgersLedgerCanisterIdAccountsCountGetRequest$inboundSchema;
  /** @deprecated use `CountAccountsApiV2LedgersLedgerCanisterIdAccountsCountGetRequest$outboundSchema` instead. */
  export const outboundSchema =
    CountAccountsApiV2LedgersLedgerCanisterIdAccountsCountGetRequest$outboundSchema;
  /** @deprecated use `CountAccountsApiV2LedgersLedgerCanisterIdAccountsCountGetRequest$Outbound` instead. */
  export type Outbound =
    CountAccountsApiV2LedgersLedgerCanisterIdAccountsCountGetRequest$Outbound;
}

export function countAccountsApiV2LedgersLedgerCanisterIdAccountsCountGetRequestToJSON(
  countAccountsApiV2LedgersLedgerCanisterIdAccountsCountGetRequest:
    CountAccountsApiV2LedgersLedgerCanisterIdAccountsCountGetRequest,
): string {
  return JSON.stringify(
    CountAccountsApiV2LedgersLedgerCanisterIdAccountsCountGetRequest$outboundSchema
      .parse(countAccountsApiV2LedgersLedgerCanisterIdAccountsCountGetRequest),
  );
}

export function countAccountsApiV2LedgersLedgerCanisterIdAccountsCountGetRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  CountAccountsApiV2LedgersLedgerCanisterIdAccountsCountGetRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      CountAccountsApiV2LedgersLedgerCanisterIdAccountsCountGetRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'CountAccountsApiV2LedgersLedgerCanisterIdAccountsCountGetRequest' from JSON`,
  );
}
